import { render, staticRenderFns } from "./ReorderForm.vue?vue&type=template&id=8fdef112&scoped=true"
import script from "./ReorderForm.vue?vue&type=script&lang=js"
export * from "./ReorderForm.vue?vue&type=script&lang=js"
import style0 from "./ReorderForm.vue?vue&type=style&index=0&id=8fdef112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fdef112",
  null
  
)

export default component.exports